<template>
  <div class="first-publish">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="暂无更多数据"
      @load="onLoad"
    >
      <div class="game-list">
        <div class="game-item" v-for="info in gameList" :key="info.game_id">
          <div class="game-item-content" @click="jumpDetail(info)">
            <img class="game-logo" :src="info.logo_url" alt="" />
            <div class="game-info">
              <div class="game-info-title">
                <h1>{{ info.game_name }}</h1>
                <span>{{ info.discount }}</span>
              </div>
              <div class="game-info-desc">
                <div class="game-info-gift">
                  <span v-if="info.wealf">福利</span>
                  <span v-if="!info.wealf && info.havaGift == 1">礼包</span>
                  <span v-if="info.isBTgame">变态特权</span>
                  <span v-if="info.waterMark == 1">专属折扣</span>
                  <span
                    v-if="
                      info.havaGift == 0 &&
                      !info.isBTgame &&
                      !info.wealf &&
                      info.waterMark == 0
                    "
                    >{{ info.title }}</span
                  >
                </div>
                <div class="star" v-if="info.starInfo">
                  <img
                    :key="star"
                    v-for="star in info.starInfo.allStar"
                    src="@/assets/images/star_all.png"
                    alt=""
                  />
                  <img
                    :key="star+999"
                    v-for="star in info.starInfo.halfStar"
                    src="@/assets/images/star_half.png"
                    alt=""
                  />
                </div>
              </div>
              <div class="game-tag">
                <span v-for="tag in info.gameType.slice(0, 2)" :key="tag">{{
                  tag
                }}</span>
                <span class="other-tag">{{ info.openServerDate }}</span>
              </div>
            </div>
            <img class="game-recommend" v-show="info.firstSend == 1" src="@/assets/images/ic_recommend_tag.png" alt="">
          </div>
          
          <!-- <div class="game-item-operate">
            <span @click="doRecharge(info, 'recharge')">充值</span>
            <span @click="doRecharge(info, 'download')">下载</span>
          </div> -->
          <operateBtns :gameInfo="info" @doOperate="doOperate" />
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
import mixins from "@/mixin";
import mixin from "@/mixin/game.js";
import operateBtns from "@/components/OperateBtns.vue"
export default {
  mixins: [mixins, mixin],
  components: {
    operateBtns
  },
  data() {
    return {
      gameList: [],
      loading: false,
      finished: false,
      location: "PUBLIC_PARISE",
      totalCount: 0,
      currentPage: 1,
    };
  },
  computed: {
    ...mapGetters(["uuid"]),
  },
  methods: {
    async onLoad() {
      await this.gameListQr();

      // 加载状态结束
      this.loading = false;

      // 数据全部加载完成
      if (this.gameList.length >= this.totalCount) {
        this.finished = true;
      } else {
        this.currentPage++;
      }
    },

    /**
     * 根据分类查询游戏列表
     */
    async gameListQr() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/web/game/getGameList.htm",
          "post",
          {
            searchParams: JSON.stringify({
              gameType: "firstPublish",
              location: "GAME_LIST",
            }),
            uuid: this.uuid,
            appType: "WM",
            currentPage: this.currentPage,
            pageSize: 30,
          }
        );
        let list = this.gameInit(data)
        this.gameList.push(...list);
        this.totalCount = totalCount;
        console.log(this.gameList, "gameList-----");
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    /**
     * 跳转游戏详情
     */
    jumpDetail(info) {
      this.$router.push({ path: "/detail", query: { gameId: info.game_id } });
    },

    doOperate(info, flag) {
      this.$emit("doOperate", info, flag);
    },
  },
};
</script>

<style lang="scss">
.first-publish {
}
</style>


// WEBPACK FOOTER //
// src/views/firstEpisode/components/FirstPublish.vue